import NotificationList from "@containers/Notification/NotificationList";
import NoMatch from "@containers/no-match";

import { ROUTES } from "@constants/routes";
import { RouteType } from "./types";

const { NOTIFICATIONS } = ROUTES.NOTIFICATION;

export const NotificationRoutes: RouteType[] = [
  {
    id: "notification_module",
    path: NOTIFICATIONS,
    children: [
      {
        id: "notification_list",
        index: true,
        element: <NotificationList />,
        redirection: <NoMatch />,
        permissions: {
          auth: ["token"],
        },
      },
    ],
  },
];
